/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class CategoryRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return hash({
      category: this.store.findRecord('posts/tag-category', params.category_id),
      tags: this.store.query('posts/tag', { categoryId: params.category_id }),
    });
  }
}
